angular.module('mibutils', [])
	.factory('utils', function() {
		return {
			containString: function(param) {
				param = param.toLowerCase();
				return function(p) {
					return p.indexOf(('' + param).toLowerCase()) > -1;
				};
			}

		};
	})
	.filter('formatDate', ['$filter',
		function($filter) {
			return function(datumStr, withTime, withoutSpaces) {
				if (!datumStr) return '';

				var formatterIN = 'YYYY-MM-DD';
				var formatterOUT = 'DD. MM. YYYY';

				if (withTime) {
					formatterOUT = 'DD.MM.YYYY HH:mm:ss';
					formatterIN = 'YYYY-MM-DDTHH:mm:ss';
				} else if (withoutSpaces) {
					formatterOUT = 'DD.MM.YYYY';
				}

				var date;
				if (datumStr instanceof Date) {
					date = moment(datumStr);
				} else if ((moment.isMoment(datumStr))) {
					date = datumStr;
				} else {
					date = moment(datumStr, formatterIN);
				}

				if (date.isValid()) {
					return date.format(formatterOUT);
				}
				return datumStr;

			};
		}
	]).filter('formatDateAdv', ['$filter',
		function($filter) {
			return function(datumStr, type) {
				if (!datumStr) return '';

				var formatterIN = 'YYYY-MM-DD';
				var formatterOUT = 'DD. MM. YYYY';

				if (type === 1) {
					// with time
					formatterOUT = 'DD.MM.YYYY HH:mm:ss';
					formatterIN = 'YYYY-MM-DDTHH:mm:ss';
				} else if (type === 2) {
					// without space
					formatterOUT = 'DD.MM.YYYY';
				} else if (type === 3) {
					// readable
					formatterOUT = 'D. M. YYYY';
				}

				var date;
				if (datumStr instanceof Date) {
					date = moment(datumStr);
				} else if ((moment.isMoment(datumStr))) {
					date = datumStr;
				} else {
					date = moment(datumStr, formatterIN);
				}

				if (date.isValid()) {
					return date.format(formatterOUT);
				}
				return datumStr;

			};
		}
	]).filter('formatAmount',
		function() {
			return function(number, decimals, units, forceFixed) {
				decimals = decimals || 0;
				units = units || "";

				if (typeof number === 'string') {
					number = number.replace(" ", "")
						.replace(",", ".");
					number = parseFloat(number);
				}

				if (!forceFixed && (number % 1 !== 0)) {
					decimals = 2;
				}

				return number.toFixed(decimals)
					.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
					.replace(".", ",") + " " + units;
			};
		}
	);